// Lazily injects the Google Maps JS API only when a component actually needs it.
// Replaces the previous eager <script> in public/index.html that loaded on every page.

const GOOGLE_MAPS_KEY = "AIzaSyCRaGjT7ucw9ovR1JVKPAYcIzwuxQaS5DY";
let mapsPromise = null;

export function loadGoogleMaps() {
  if (typeof window === "undefined") return Promise.resolve(null);
  if (window.google && window.google.maps) return Promise.resolve(window.google);
  if (mapsPromise) return mapsPromise;

  mapsPromise = new Promise((resolve, reject) => {
    const cb = "__fsGoogleMapsLoaded";
    window[cb] = () => {
      resolve(window.google);
      try { delete window[cb]; } catch (e) { /* noop */ }
    };
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_KEY}&callback=${cb}&loading=async`;
    s.async = true;
    s.defer = true;
    s.onerror = () => {
      mapsPromise = null;
      reject(new Error("Google Maps failed to load"));
    };
    document.head.appendChild(s);
  });

  return mapsPromise;
}
